import classNames from 'classnames'
import Text from '@/stories/components/Common/NewText'
import { getLastUpdatedTime } from '@/revamp/pods/common/utils/get-last-update'
import useLivePrice from '@/hooks/useLivePrice'

type PriceTickerProps = {
  live_price: number
  day_change: number
  day_change_percentage: number
  currencySymbol?: string
  ticker?: string
  currency?: TCurrency
  apiUrl?: string
  isMarketOpen?: boolean
  last_updated?: string
  showLiveMarket?: boolean
}

type TCurrency = 'USD' | 'INR'

export const PriceTicker = ({
  live_price,
  day_change,
  day_change_percentage,
  currencySymbol,
  ticker,
  currency,
  apiUrl,
  isMarketOpen,
  last_updated,
  showLiveMarket,
}: PriceTickerProps) => {
  const { livePrice, dayChange, dayChangePercentage, lastUpdated } =
    useLivePrice({
      ticker,
      currency,
      apiUrl,
      isMarketOpen,
    })

  const livePriceData = {
    live_price: livePrice ?? (live_price ? Number(live_price) : undefined),
    day_change: dayChange ?? (day_change ? Number(day_change) : undefined),
    day_change_percentage:
      dayChangePercentage ??
      (day_change_percentage ? Number(day_change_percentage) : undefined),
    last_updated: lastUpdated ?? last_updated,
  }

  const isNegative = livePriceData.day_change && livePriceData.day_change < 0
  const arrow = isNegative ? '' : '+'

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center space-x-2 text-base">
        {!!(livePriceData.live_price === 0 || livePriceData.live_price) && (
          <Text appearance="heading1" addClassName="font-medium">
            {currencySymbol}
            {livePriceData.live_price.toFixed(2)}
          </Text>
        )}

        {!!(livePriceData.day_change === 0 || livePriceData.day_change) && (
          <Text
            appearance="heading3"
            addClassName={classNames({
              'text-brand-red-cinnabar': isNegative,
              'text-brand-green-dark': !isNegative,
            })}
          >
            {arrow}
            {livePriceData.day_change?.toFixed(2)}
          </Text>
        )}

        {(livePriceData.day_change_percentage === 0 ||
          livePriceData.day_change_percentage) && (
          <Text
            appearance="heading3"
            addClassName={classNames({
              'text-brand-red-cinnabar': isNegative,
              'text-brand-green-dark': !isNegative,
            })}
          >
            ({arrow}
            {livePriceData.day_change_percentage.toFixed(2)}%)
          </Text>
        )}
        {showLiveMarket && (
          <Text
            appearance="overline"
            addClassName="animate-liveMarket text-brand-white w-fit rounded-xl px-2 py-0.5 font-medium"
          >
            Live
          </Text>
        )}
      </div>
      {livePriceData.last_updated && (
        <Text appearance="caption" addClassName="text-brand-grey-base">
          as on{' '}
          <time dateTime={livePriceData.last_updated}>
            {getLastUpdatedTime(livePriceData.last_updated)} IST
          </time>
        </Text>
      )}
    </div>
  )
}
